import UsaXSpinner from "./UsaXSpinner";

export default function LoadingOverlay() {
  return (
    <div className="flex h-screen w-full flex-col items-center justify-center gap-5 bg-slate-100">
      <UsaXSpinner />
    </div>
  );
}
